var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{style:('border-radius: 25%; border: ' + _vm.borderSize + ' solid #fff !important'),attrs:{"color":_vm.backgroundColor,"size":_vm.size}},[_c('span',{style:(_vm.style)},[_vm._v("B")])])
}
var staticRenderFns = []

export { render, staticRenderFns }